import React, { useState, useEffect } from 'react';
import { useNavigate, Link, useParams } from 'react-router-dom';
import { Card, CardContent } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Textarea } from '../../components/ui/textarea';
import { ArrowLeft, Save, Home, Info, Phone, Loader2, Image, X, Plus, Video, Play, FileText } from 'lucide-react';
import { pagesAPI, imagesAPI } from '../../services/api';

// Helper to check if URL is video
const isVideoUrl = (url) => {
  if (!url) return false;
  const ext = url.split('.').pop()?.toLowerCase().split('?')[0];
  return ['mp4', 'webm', 'mov', 'avi', 'mpeg'].includes(ext);
};

const AdminPageEditor = () => {
  const navigate = useNavigate();
  const { page } = useParams(); // 'inicio', 'sobre', 'contato'
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [content, setContent] = useState({});
  const [saveMessage, setSaveMessage] = useState('');
  const [showImageLibrary, setShowImageLibrary] = useState(false);
  const [libraryImages, setLibraryImages] = useState([]);
  const [loadingImages, setLoadingImages] = useState(false);

  const pageConfig = {
    inicio: {
      title: 'Editar Página Início',
      icon: Home,
      fields: [
        { key: 'heroTitle', label: 'Título Principal (Hero)', type: 'text', placeholder: 'Viaje pelo Brasil e pelo mundo...' },
        { key: 'heroSubtitle', label: 'Subtítulo do Hero', type: 'text', placeholder: 'Turismo de aventura com segurança...' },
        { key: 'heroButtonText', label: 'Texto do Botão Hero', type: 'text', placeholder: 'Conheça nossos Pacotes' },
        { key: 'sectionTitle', label: 'Título da Seção de Pacotes', type: 'text', placeholder: 'Nossas Soluções de Viagem' },
        { key: 'sectionSubtitle', label: 'Subtítulo da Seção de Pacotes', type: 'text', placeholder: 'Experiências únicas para cada tipo de viajante' },
        { key: 'whyTravelTitle', label: 'Título "Por que viajar conosco"', type: 'text', placeholder: 'Por que viajar com a TÔ INDO ALI?' },
        { key: 'whyTravelSubtitle', label: 'Subtítulo "Por que viajar conosco"', type: 'text', placeholder: 'Segurança, profissionalismo e paixão por aventura' },
        { key: 'feature1Title', label: 'Diferencial 1 - Título', type: 'text', placeholder: 'Segurança Total' },
        { key: 'feature1Desc', label: 'Diferencial 1 - Descrição', type: 'text', placeholder: 'Seguro viagem e equipe especializada...' },
        { key: 'feature2Title', label: 'Diferencial 2 - Título', type: 'text', placeholder: 'Guias Certificados' },
        { key: 'feature2Desc', label: 'Diferencial 2 - Descrição', type: 'text', placeholder: 'Profissionais com Cadastur...' },
        { key: 'feature3Title', label: 'Diferencial 3 - Título', type: 'text', placeholder: 'Atendimento Humanizado' },
        { key: 'feature3Desc', label: 'Diferencial 3 - Descrição', type: 'text', placeholder: 'Cuidamos de cada detalhe...' },
        { key: 'feature4Title', label: 'Diferencial 4 - Título', type: 'text', placeholder: 'Experiência Completa' },
        { key: 'feature4Desc', label: 'Diferencial 4 - Descrição', type: 'text', placeholder: 'Roteiros exclusivos...' },
        { key: 'ctaTitle', label: 'Título CTA Final', type: 'text', placeholder: 'Pronto para a sua próxima aventura?' },
        { key: 'ctaSubtitle', label: 'Subtítulo CTA Final', type: 'text', placeholder: 'Entre em contato e descubra o pacote perfeito...' },
        { key: 'stat1Value', label: 'Estatística 1 - Valor', type: 'text', placeholder: '500+' },
        { key: 'stat1Label', label: 'Estatística 1 - Label', type: 'text', placeholder: 'Viagens Realizadas' },
        { key: 'stat2Value', label: 'Estatística 2 - Valor', type: 'text', placeholder: '8+' },
        { key: 'stat2Label', label: 'Estatística 2 - Label', type: 'text', placeholder: 'Anos de Experiência' },
        { key: 'stat3Value', label: 'Estatística 3 - Valor', type: 'text', placeholder: '50+' },
        { key: 'stat3Label', label: 'Estatística 3 - Label', type: 'text', placeholder: 'Destinos' },
        { key: 'stat4Value', label: 'Estatística 4 - Valor', type: 'text', placeholder: '4.9' },
        { key: 'stat4Label', label: 'Estatística 4 - Label', type: 'text', placeholder: 'Avaliação Google' }
      ]
    },
    sobre: {
      title: 'Editar Página Sobre Nós',
      icon: Info,
      hasHeroImages: true, // Adicionar opção de fotos
      fields: [
        { key: 'pageTitle', label: 'Título da Página', type: 'text', placeholder: 'Sobre a TÔ INDO ALI' },
        { key: 'pageSubtitle', label: 'Subtítulo da Página', type: 'text', placeholder: 'Conheça nossa história e paixão por aventuras' },
        { key: 'historyTitle', label: 'Título da Seção História', type: 'text', placeholder: 'Nossa História' },
        { key: 'historyText', label: 'Texto da História', type: 'textarea', placeholder: 'A TÔ INDO ALI nasceu da paixão por viagens e aventuras...' },
        { key: 'missionTitle', label: 'Título Missão', type: 'text', placeholder: 'Nossa Missão' },
        { key: 'missionText', label: 'Texto da Missão', type: 'textarea', placeholder: 'Proporcionar experiências de viagem únicas e inesquecíveis...' },
        { key: 'visionTitle', label: 'Título Visão', type: 'text', placeholder: 'Nossa Visão' },
        { key: 'visionText', label: 'Texto da Visão', type: 'textarea', placeholder: 'Ser referência em turismo de aventura no Brasil...' },
        { key: 'valuesTitle', label: 'Título Valores', type: 'text', placeholder: 'Nossos Valores' },
        { key: 'value1Title', label: 'Valor 1 - Título', type: 'text', placeholder: 'Segurança' },
        { key: 'value1Desc', label: 'Valor 1 - Descrição', type: 'text', placeholder: 'Priorizamos a segurança em todas as nossas expedições' },
        { key: 'value2Title', label: 'Valor 2 - Título', type: 'text', placeholder: 'Paixão' },
        { key: 'value2Desc', label: 'Valor 2 - Descrição', type: 'text', placeholder: 'Amor pelo turismo de aventura move cada ação' },
        { key: 'value3Title', label: 'Valor 3 - Título', type: 'text', placeholder: 'Respeito' },
        { key: 'value3Desc', label: 'Valor 3 - Descrição', type: 'text', placeholder: 'Respeito às comunidades locais e meio ambiente' },
        { key: 'value4Title', label: 'Valor 4 - Título', type: 'text', placeholder: 'Excelência' },
        { key: 'value4Desc', label: 'Valor 4 - Descrição', type: 'text', placeholder: 'Buscamos excelência em cada detalhe' },
        { key: 'differentialsTitle', label: 'Título Seção Diferenciais', type: 'text', placeholder: 'Nossos Diferenciais' },
        { key: 'differentialsSubtitle', label: 'Subtítulo Diferenciais', type: 'text', placeholder: 'O que nos torna especiais' },
        { key: 'differential1', label: 'Diferencial 1', type: 'text', placeholder: 'Seguro viagem incluso' },
        { key: 'differential2', label: 'Diferencial 2', type: 'text', placeholder: 'Guias certificados' },
        { key: 'differential3', label: 'Diferencial 3', type: 'text', placeholder: 'Roteiros exclusivos' },
        { key: 'differential4', label: 'Diferencial 4', type: 'text', placeholder: 'Atendimento 24h' },
        { key: 'differential5', label: 'Diferencial 5', type: 'text', placeholder: 'Grupos pequenos' },
        { key: 'differential6', label: 'Diferencial 6', type: 'text', placeholder: 'Experiência personalizada' },
        { key: 'cadasturNumber', label: 'Número Cadastur', type: 'text', placeholder: '46.231.427/0001-00' }
      ]
    },
    contato: {
      title: 'Editar Página Contato',
      icon: Phone,
      fields: [
        { key: 'pageTitle', label: 'Título da Página', type: 'text', placeholder: 'Entre em Contato' },
        { key: 'pageSubtitle', label: 'Subtítulo da Página', type: 'text', placeholder: 'Estamos prontos para ajudar você a planejar sua próxima aventura' },
        { key: 'whatsappNumber', label: 'WhatsApp (só números)', type: 'text', placeholder: '5521979652791' },
        { key: 'whatsappDisplay', label: 'WhatsApp (exibição)', type: 'text', placeholder: '(21) 97965-2791' },
        { key: 'email', label: 'E-mail', type: 'text', placeholder: 'contato@toindoali.com.br' },
        { key: 'address', label: 'Endereço', type: 'text', placeholder: 'Rio de Janeiro, RJ' },
        { key: 'instagramUrl', label: 'URL Instagram', type: 'text', placeholder: 'https://www.instagram.com/toindoali.tur/' },
        { key: 'instagramUser', label: '@Instagram', type: 'text', placeholder: '@toindoali.tur' },
        { key: 'facebookUrl', label: 'URL Facebook', type: 'text', placeholder: 'https://www.facebook.com/...' },
        { key: 'workingHours', label: 'Horário de Atendimento', type: 'text', placeholder: 'Segunda a Sexta: 9h às 18h' },
        { key: 'whatsappMessage', label: 'Mensagem Padrão WhatsApp', type: 'textarea', placeholder: 'Olá! Vim pelo site da TÔ INDO ALI e quero informações sobre os pacotes de viagem.' },
        { key: 'mapEmbed', label: 'Código Embed do Google Maps (iframe)', type: 'textarea', placeholder: '<iframe src="https://www.google.com/maps/embed?..." />' }
      ]
    },
    'termo-adesao': {
      title: 'Editar Termo de Adesão',
      icon: FileText,
      isHtmlEditor: true,
      fields: [
        { key: 'htmlContent', label: 'Conteúdo HTML do Termo de Adesão e Política de Cancelamento', type: 'html', placeholder: '<h1>TERMO DE ADESÃO...</h1>' }
      ]
    }
  };

  const currentConfig = pageConfig[page] || pageConfig.inicio;
  const PageIcon = currentConfig.icon;

  useEffect(() => {
    const auth = sessionStorage.getItem('adminAuth');
    if (!auth) {
      navigate('/admin/login');
      return;
    }
    loadContent();
  }, [navigate, page]);

  const loadContent = async () => {
    setLoading(true);
    setSaveMessage('');
    try {
      // Adicionar timestamp para evitar cache
      const data = await pagesAPI.getByName(page);
      console.log(`[AdminPageEditor] Dados carregados para ${page}:`, data?.content);
      if (data && data.content) {
        setContent(data.content);
      } else {
        // Use placeholders as defaults
        const defaults = {};
        currentConfig.fields.forEach(field => {
          defaults[field.key] = field.placeholder || '';
        });
        setContent(defaults);
      }
    } catch (error) {
      console.error('Erro ao carregar conteúdo:', error);
      // Use placeholders as defaults on error
      const defaults = {};
      currentConfig.fields.forEach(field => {
        defaults[field.key] = field.placeholder || '';
      });
      setContent(defaults);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (key, value) => {
    setContent(prev => ({ ...prev, [key]: value }));
    setSaveMessage('');
  };

  const handleSave = async () => {
    setSaving(true);
    setSaveMessage('');
    try {
      await pagesAPI.save(page, content);
      setSaveMessage('✅ Conteúdo salvo com sucesso!');
    } catch (error) {
      console.error('Erro ao salvar:', error);
      setSaveMessage('❌ Erro ao salvar: ' + (error.response?.data?.detail || error.message));
    } finally {
      setSaving(false);
    }
  };

  // Carregar imagens da biblioteca
  const loadLibraryImages = async () => {
    setLoadingImages(true);
    try {
      const images = await imagesAPI.getAll();
      setLibraryImages(images || []);
    } catch (error) {
      console.error('Erro ao carregar imagens:', error);
      setLibraryImages([]);
    } finally {
      setLoadingImages(false);
    }
  };

  // Abrir modal de seleção de imagens
  const openImageLibrary = () => {
    setShowImageLibrary(true);
    loadLibraryImages();
  };

  // Adicionar imagem ao Hero
  const addHeroImage = (imageUrl) => {
    const currentImages = content.heroImages || [];
    if (!currentImages.includes(imageUrl)) {
      handleChange('heroImages', [...currentImages, imageUrl]);
    }
  };

  // Remover imagem do Hero
  const removeHeroImage = (index) => {
    const currentImages = content.heroImages || [];
    const newImages = currentImages.filter((_, i) => i !== index);
    handleChange('heroImages', newImages);
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center">
        <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-[#003366]"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-100">
      {/* Header */}
      <header className="bg-[#003366] text-white shadow-lg">
        <div className="max-w-7xl mx-auto px-4 py-4 flex items-center justify-between">
          <div className="flex items-center space-x-4">
            <Link to="/admin/dashboard" className="hover:text-[#FFD700]">
              <ArrowLeft className="w-6 h-6" />
            </Link>
            <PageIcon className="w-6 h-6" />
            <h1 className="text-xl font-bold">{currentConfig.title}</h1>
          </div>
          <Button
            onClick={handleSave}
            disabled={saving}
            className="bg-[#FFD700] hover:bg-[#FFC700] text-gray-900"
          >
            {saving ? (
              <><Loader2 className="w-4 h-4 mr-2 animate-spin" />Salvando...</>
            ) : (
              <><Save className="w-4 h-4 mr-2" />Salvar Alterações</>
            )}
          </Button>
        </div>
      </header>

      <div className="max-w-4xl mx-auto px-4 py-8">
        {saveMessage && (
          <div className={`mb-4 p-4 rounded-lg ${saveMessage.includes('✅') ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
            {saveMessage}
          </div>
        )}

        <Card>
          <CardContent className="p-6">
            <div className="space-y-6">
              {currentConfig.fields.map((field, index) => (
                <div key={index}>
                  <Label htmlFor={field.key}>{field.label}</Label>
                  {field.type === 'html' ? (
                    <div className="mt-1">
                      <Textarea
                        id={field.key}
                        value={content[field.key] || ''}
                        onChange={(e) => handleChange(field.key, e.target.value)}
                        placeholder={field.placeholder}
                        className="font-mono text-sm"
                        rows={30}
                      />
                      <p className="text-xs text-gray-500 mt-2">
                        Use tags HTML como &lt;h1&gt;, &lt;h2&gt;, &lt;h3&gt;, &lt;p&gt;, &lt;ul&gt;, &lt;li&gt;, &lt;strong&gt;, etc.
                      </p>
                      {content[field.key] && (
                        <div className="mt-4 p-4 bg-gray-50 rounded-lg border">
                          <Label className="text-sm font-semibold mb-2 block">Pré-visualização:</Label>
                          <div 
                            className="prose prose-sm max-w-none"
                            dangerouslySetInnerHTML={{ __html: content[field.key] }}
                          />
                        </div>
                      )}
                    </div>
                  ) : field.type === 'textarea' ? (
                    <Textarea
                      id={field.key}
                      value={content[field.key] || ''}
                      onChange={(e) => handleChange(field.key, e.target.value)}
                      placeholder={field.placeholder}
                      className="mt-1"
                      rows={4}
                    />
                  ) : (
                    <Input
                      id={field.key}
                      value={content[field.key] || ''}
                      onChange={(e) => handleChange(field.key, e.target.value)}
                      placeholder={field.placeholder}
                      className="mt-1"
                    />
                  )}
                </div>
              ))}
            </div>

            {/* Seção de Imagens do Hero (para páginas inicio e sobre) */}
            {(page === 'inicio' || currentConfig.hasHeroImages) && (
              <div className="mt-8 pt-6 border-t">
                <div className="flex items-center justify-between mb-4">
                  <div>
                    <Label className="text-lg font-semibold">Imagens do Hero Slider</Label>
                    <p className="text-sm text-gray-500 mt-1">
                      Selecione as imagens que serão exibidas no slider principal da página inicial
                    </p>
                  </div>
                  <Button
                    type="button"
                    variant="outline"
                    onClick={openImageLibrary}
                    className="flex items-center"
                  >
                    <Plus className="w-4 h-4 mr-2" />
                    Adicionar Imagem
                  </Button>
                </div>

                {/* Imagens/Vídeos selecionados */}
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                  {(content.heroImages || []).map((mediaUrl, index) => {
                    const isVideo = isVideoUrl(mediaUrl);
                    return (
                      <div key={index} className="relative group">
                        {isVideo ? (
                          <video
                            src={mediaUrl}
                            className="w-full h-32 object-cover rounded-lg border"
                            muted
                            onMouseEnter={(e) => e.target.play()}
                            onMouseLeave={(e) => { e.target.pause(); e.target.currentTime = 0; }}
                          />
                        ) : (
                          <img
                            src={mediaUrl}
                            alt={`Hero ${index + 1}`}
                            className="w-full h-32 object-cover rounded-lg border"
                          />
                        )}
                        {isVideo && (
                          <div className="absolute top-2 left-2 bg-black/70 text-white px-2 py-1 rounded-full flex items-center gap-1 text-xs">
                            <Play className="w-3 h-3" fill="white" />
                            Vídeo
                          </div>
                        )}
                        <button
                          type="button"
                          onClick={() => removeHeroImage(index)}
                          className="absolute top-2 right-2 bg-red-500 text-white p-1 rounded-full opacity-0 group-hover:opacity-100 transition-opacity"
                        >
                          <X className="w-4 h-4" />
                        </button>
                        <div className="absolute bottom-2 left-2 bg-black/60 text-white text-xs px-2 py-1 rounded">
                          {index + 1}º
                        </div>
                      </div>
                    );
                  })}
                  {(content.heroImages || []).length === 0 && (
                    <div className="col-span-full text-center py-8 text-gray-500 border-2 border-dashed rounded-lg">
                      <div className="flex justify-center gap-2 mb-2">
                        <Image className="w-10 h-10 text-gray-400" />
                        <Video className="w-10 h-10 text-gray-400" />
                      </div>
                      <p>Nenhuma mídia selecionada</p>
                      <p className="text-sm">Clique em &quot;Adicionar Imagem&quot; para selecionar</p>
                    </div>
                  )}
                </div>
              </div>
            )}

            <div className="mt-8 pt-6 border-t flex justify-between">
              <Link to="/admin/dashboard">
                <Button variant="outline">Voltar ao Dashboard</Button>
              </Link>
              <Button
                onClick={handleSave}
                disabled={saving}
                className="bg-[#003366] hover:bg-[#002244] text-white"
              >
                {saving ? (
                  <><Loader2 className="w-4 h-4 mr-2 animate-spin" />Salvando...</>
                ) : (
                  <><Save className="w-4 h-4 mr-2" />Salvar Alterações</>
                )}
              </Button>
            </div>
          </CardContent>
        </Card>

        <div className="mt-4 p-4 bg-green-50 border border-green-200 rounded-lg">
          <p className="text-sm text-green-800">
            <strong>✅ Integrado ao banco de dados:</strong> As alterações salvas aqui serão aplicadas imediatamente 
            nas respectivas páginas do site e ficam salvas permanentemente.
          </p>
        </div>
      </div>

      {/* Modal da Biblioteca de Mídia */}
      {showImageLibrary && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg w-full max-w-4xl max-h-[80vh] overflow-hidden">
            <div className="p-4 border-b flex items-center justify-between">
              <h3 className="text-lg font-semibold">Biblioteca de Mídia</h3>
              <button
                onClick={() => setShowImageLibrary(false)}
                className="text-gray-500 hover:text-gray-700"
              >
                <X className="w-6 h-6" />
              </button>
            </div>
            <div className="p-4 overflow-y-auto max-h-[60vh]">
              {loadingImages ? (
                <div className="text-center py-8">
                  <Loader2 className="w-8 h-8 animate-spin mx-auto text-[#003366]" />
                  <p className="mt-2 text-gray-500">Carregando mídia...</p>
                </div>
              ) : libraryImages.length === 0 ? (
                <div className="text-center py-8 text-gray-500">
                  <div className="flex justify-center gap-2 mb-4">
                    <Image className="w-12 h-12 text-gray-400" />
                    <Video className="w-12 h-12 text-gray-400" />
                  </div>
                  <p>Nenhuma mídia na biblioteca</p>
                  <p className="text-sm mt-2">Faça upload na seção &quot;Biblioteca de Mídia&quot; do dashboard</p>
                </div>
              ) : (
                <div className="grid grid-cols-3 md:grid-cols-4 gap-4">
                  {libraryImages.map((media) => {
                    const isSelected = (content.heroImages || []).includes(media.url);
                    const isVideo = isVideoUrl(media.url) || media.media_type === 'video' || media.content_type?.startsWith('video/');
                    return (
                      <div
                        key={media.id}
                        onClick={() => {
                          if (!isSelected) {
                            addHeroImage(media.url);
                          }
                        }}
                        className={`cursor-pointer rounded-lg overflow-hidden border-2 transition-all relative ${
                          isSelected
                            ? 'border-green-500 opacity-50'
                            : 'border-transparent hover:border-[#003366]'
                        }`}
                      >
                        {isVideo ? (
                          <video
                            src={media.url}
                            className="w-full h-24 object-cover"
                            muted
                            onMouseEnter={(e) => e.target.play()}
                            onMouseLeave={(e) => { e.target.pause(); e.target.currentTime = 0; }}
                          />
                        ) : (
                          <img
                            src={media.url}
                            alt={media.name || 'Mídia'}
                            className="w-full h-24 object-cover"
                          />
                        )}
                        {isVideo && (
                          <div className="absolute top-1 right-1 bg-black/70 text-white px-1.5 py-0.5 rounded-full flex items-center gap-1 text-xs">
                            <Play className="w-2.5 h-2.5" fill="white" />
                          </div>
                        )}
                        {isSelected && (
                          <div className="bg-green-500 text-white text-xs text-center py-1">
                            Já selecionada
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
            <div className="p-4 border-t flex justify-end">
              <Button
                onClick={() => setShowImageLibrary(false)}
                className="bg-[#003366] hover:bg-[#002244] text-white"
              >
                Fechar
              </Button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminPageEditor;
